module.exports = __webpack_public_path__ + "static/Yasintha-18c53a817503915dbd31255582d5b670.jpg";